import { FC } from 'react';

import DonorDetailsStubContent from '../DonorDetailsTabContent';

const RecruiterDonorDetails: FC = () => {
  return <DonorDetailsStubContent />;
};

export default RecruiterDonorDetails;
